<!--
 * @Author: WangWenqi
 * @Date: 2024-12-24 14:52:01
 * @Description: 合同新增查看
-->
<template>
  <div class="contract-template-wrap">
    <div class="title_with_line" style="box-sizing: border-box; padding: 20px">
      合同信息
    </div>
    <div
      style="flex: 1; overflow-y: auto; box-sizing: border-box; padding: 0 20px"
    >
      <ContractDetail
        ref="contractDetailRef"
        :disabled="!!id"
        :tableColMid="tableColMid"
        :detail="detail"
        prefix="合同"
        v-slot="{ formData }"
        :pageType="ContractMenuType.MANAGEMENT"
        :contractType="contractType"
        v-if="contractType === ContractType.AGENCY_SERVICE || detail.id"
      >
        <!-- 只有市场服务合同展示-暂时先都不展示 -->
        <template v-if="false">
          <!-- <template v-if="+contractType === ContractType.MARKET"> -->
          <div class="title_with_line">填写合同价格</div>
          <BaseFormItem label="预计结算总金额" prop="budgetSettlement">
            <BaseInputNumber
              :disabled="true"
              :min="0"
              :max="100000000"
              :precision="2"
              v-model="formData.budgetSettlement"
              :controls="false"
              style="width: 248px"
            />
          </BaseFormItem>
          <base-table
            :data="formData.budgetList"
            :columns="columns"
          ></base-table>
        </template>
      </ContractDetail>
      <div
        v-else
        v-xrk-loading="true"
        style="width: 100%; height: 400px"
        element-loading-text="加载中..."
      ></div>
    </div>
    <div class="affix-box">
      <BaseButton @click="handleCancel" type="default">返回</BaseButton>
      <BaseButton
        v-if="contractType === ContractType.AGENCY_SERVICE"
        style="margin-left: 16px"
        type="primary"
        :click="handleConfirm"
      >
        保存
      </BaseButton>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ContractDetail from '../components/contract-detail.vue';
import {
  BaseFormItem,
  BaseButton,
  useTableColumn,
  BaseRadioGroup,
  BaseRadio,
  BaseInputNumber,
  BaseTable
} from 'xrk-components';
import { addOrUpdateContract, getContractDetail } from '../data-source/apis';
import {
  ContractMenuType,
  ContractStatus,
  RoleType,
  ContractType
} from '../constants';
import { formatter, translator } from '@/utils';

const router = useRouter();
const route = useRoute();

const { id, tab } = route.query as {
  id: string;
  tab: string;
};
const contractType = ref(+tab);

const { parentPath, roleText } = route.meta;

const detail = ref<any>({
  firstStatus: ContractStatus.COMPLETED,
  secondStatus: ContractStatus.COMPLETED
});

const contractDetailRef = ref();
const columns = [
  useTableColumn({
    type: 'index',
    label: '序号'
  }),
  useTableColumn({
    label: '服务项目',
    prop: 'serviceProjectName'
  }),
  useTableColumn({
    label: '服务场景',
    prop: 'sceneName'
  }),
  useTableColumn({
    label: '甲乙结算单价（不含税/元）',
    prop: 'settlementPrice',
    formatter: ({ cellValue }) => formatter.fen2yuan(cellValue, '元')
  }),
  useTableColumn({
    label: '与自由职业者结算单价',
    prop: 'liberalPrice',
    formatter: ({ cellValue }) => formatter.fen2yuan(cellValue, '元')
  }),
  useTableColumn({
    label: '结算单税率',
    prop: 'settlementScale',
    formatter: ({ cellValue }) =>
      cellValue === null ? '-' : `${Number(cellValue).toFixed(2)}%`
  }),
  useTableColumn({
    label: '平台服务费',
    prop: 'platformServiceScale',
    formatter: ({ cellValue }) =>
      cellValue === null ? '-' : `${Number(cellValue).toFixed(2)}%`
  }),
  useTableColumn({
    label: '服务费占比',
    prop: 'serviceChargeScale',
    formatter: ({ cellValue }) =>
      cellValue === null ? '-' : `${Number(cellValue).toFixed(2)}%`
  })
];

const handleConfirm = () => {
  contractDetailRef.value.submit().then(async res => {
    const params = {
      ...res,
      contractName: res.contractTemplateName,
      type: res.contractType,
      contractRenderUrl: res.contractTemplateUrl,
      budgetSettlement: +translator.yuan2fen(+res.budgetSettlement)
    };
    if (id) {
      params.id = id;
    }
    delete params.contractTemplateName;
    delete params.budgetList;
    delete params.contractType;
    delete params.contractTemplateUrl;
    await addOrUpdateContract(params);
    goBack();
  });
};

const tableColMid = formData => [
  useTableColumn({
    label: '签署状态',
    prop: 'signStatus',
    render: ({ index }) => (
      <BaseFormItem
        prop={`${index === 0 ? 'first' : 'second'}Status`}
        rules={[
          {
            required: true,
            message: '请选择签署状态',
            trigger: 'change'
          }
        ]}
      >
        <BaseRadioGroup
          v-model={formData.value[`${index === 0 ? 'first' : 'second'}Status`]}
          disabled={true}
        >
          <BaseRadio value={ContractStatus.COMPLETED}>已签</BaseRadio>
          <BaseRadio value={ContractStatus.UNSIGNED}>未签</BaseRadio>
        </BaseRadioGroup>
      </BaseFormItem>
    )
  })
];

const goBack = () => {
  router.push(`${parentPath}?tab=${tab}`);
};

const handleCancel = () => {
  goBack();
};

const getDetail = () => {
  id &&
    getContractDetail({
      id: id,
      roleType: RoleType[String(roleText).toUpperCase()]
    }).then(({ data }) => {
      detail.value = {
        ...data,
        budgetSettlement: +formatter.fen2yuan(data.budgetSettlement || 0),
        contractTemplateName: data.contractName,
        budgetList: data.budgets,
        contractTemplateUrl: data.contractRenderUrl,
        contractType: data.type
      };
      contractType.value = data.type;
    });
};

getDetail();
</script>
<style lang="scss" scoped>
@import '@/styles/ui.scss';

.contract-template-wrap {
  padding: 0;
  display: flex;
  flex-direction: column;
}
</style>
